module.exports = __webpack_public_path__ + "static/media/expend4.4af9fb7.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/expend4.mp4
// module id = HJGK
// module chunks = 0